import React, { useEffect, useState } from "react";
import performRequest from "../../api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";

const WebinarStats = ({ data = {} }) => {
  const [webinarStats, setWebinarStats] = useState();
  useEffect(() => {
    performRequest("GET", "/webinar/getWebinarStats")
      .then((res) => {
        if (res.status === 200) {
          // Assuming res.data contains the stats data
          setWebinarStats(res.data);
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  return (
    <div className="row row-deck row-cards">
      <div className="col-12">
        <div className="card bg-azure-lt card-sm">
          <div className="card-body justify-content-center align-items-center d-flex ">
            <div className="">
              <div
                className="text-center fw-bold"
                style={{ fontSize: "1.9rem" }}
              >
                {webinarStats?.webinarAttendeeCount || 0} /{" "}
                {webinarStats?.totalWebinarPurchases || 0}
              </div>
              <div class="fw-bold text-center">
                Total Attendees / Total Enroll
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12">
        <div className="card bg-azure-lt card-sm">
          <div className="card-body justify-content-center align-items-center d-flex ">
            <div className="">
              <div
                className=" text-center fw-bold "
                style={{ fontSize: "1.9rem" }}
              >
                {webinarStats?.discountedPayments || 0} /{" "}
                {webinarStats?.totalWebinarPurchases -
                  webinarStats?.discountedPayments || 0}
              </div>
              <div className=" fw-bold text-center">Discounted / Payments</div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12">
        <div className="card bg-azure-lt card-sm">
          <div className="card-body justify-content-center align-items-center d-flex ">
            <div className="p-0 m-0">
              <div
                className="fw-bold text-center"
                style={{ fontSize: "1.9rem" }}
              >
                {`₹${webinarStats?.totalAmount}`}
              </div>
              <div className="text-center fw-bold">Total Revenue</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebinarStats;
